// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import '@/assets/css/common.scss'
import Vue from 'vue'
import './config/mint-ui'
import App from './App'
import store from './vuex'
import http from './config/http'
import Url from './config/url'
import './config/element-ui'
import '../theme/index.css'
import cookie from './config/cookie'
import Navigation from 'vue-navigation'
import * as commonJs from './config/common'
import 'lib-flexible/flexible'
import router from './router'
import JsonExcel from 'vue-json-excel'
import 'babel-polyfill'
import promise from 'es6-promise'
import JSEncrypt from 'jsencrypt'
import wx from 'weixin-js-sdk'

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

// Vue.use(router)
Vue.use(Navigation, {router, store})
Vue.prototype.http = http
Vue.prototype.Url = Url
Vue.prototype.wx = wx
Vue.prototype.$commonJs = commonJs
Vue.prototype.$cookie = cookie
Vue.config.productionTip = false
Vue.use(require('vue-wechat-title'))
Vue.component('downloadExcel', JsonExcel)
window.vm = new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: { App },
  render: h => h(App)
})
// App.commandLine.appendSwitch('ignore-certificate-errors')
promise.polyfill()
// 路由守卫
router.beforeEach((to, form, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  if (to.matched.some(record => record.meta.isLogin)) {
    let isLogin = cookie.get('isLogin')
    console.log(isLogin)
    if (cookie.get('isLogin') === null || localStorage.getItem('userInfo') === null) {
      // 未登录，去登录
      store.commit('LOSELOGIN')
      next({
        path: '/login',
        query: { redirect: to.fullPath } // 将跳转的路由path作为参数，登录成功后跳转该路由
      })
      next()
    } else {
      next()
    }
  } else {
    next()
  }
})
// RSA加密
Vue.prototype.$getRsaCode = function (str) {
  let pubKey = `MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCPWzp6uqOh46ac3fkTjyVUEIxFITI+FM4NpT0JWNwRCLoXATjyK+5xWBZiaDjBYZ59FsBYQUQyqlAL1X80IcVG7URptXIng2okL44GqgLTUeso4QCf0G4m49gsXeWeh/b+IrEZ7cHMgc7tUIS2EN8z09JRNBxpGSQVMo8wT4Yf2wIDAQAB` // ES6 模板字符串 引用 rsa 公钥
  let encryptStr = new JSEncrypt()
  encryptStr.setPublicKey(pubKey) // 设置 加密公钥
  let data = encryptStr.encrypt(str.toString()) // 进行加密
  return data
}
Vue.prototype.$getRsaCode2 = function (str) {
  let pubKey = `MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAwVwJ12WGdZBJApmMgj0hNQWQzbHDuEoHHYJIavS1raCbIOgXAxBAyzRjasrkXefDY0qL2pwFKaijhOMY46c357BEd+tr6OuixZHw/GNms4Aytd4AQFhOoZw3LOO58GPq5SaAYZ16bHaCtmVHEf9eQUkAA5QMnd2+ZuykkGnE0mMS6asGJ3D0sedh0Q2fu64ekJqlfa/4BBKbljxzgNH4KbG6TcrTxSu56iGTUiQK/F76E4BnPtejdtDPbClf2qrXyY+YidMtliRnorrK1k7f3PYiU16124eist70D5QcIxCS983apg5wquoAz2OW6+C4xSHLADEUka+SpmLL9NgE/QIDAQAB` // ES6 模板字符串 引用 rsa 公钥
  let encryptStr = new JSEncrypt()
  encryptStr.setPublicKey(pubKey) // 设置 加密公钥
  let data = encryptStr.encrypt(str.toString()) // 进行加密
  return data
}



// WEBPACK FOOTER //
// ./src/main.js